// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5066":"03621241","5478":"e29eb44f"}[chunkId] + ".chunk.js";
};